import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { StepControls } from "../StepControls";
import { RenderFormFields } from "src/components/RenderFormFields";
import { getIndustryField } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { useAppSelector } from "src/hooks/redux";
import { selectIndustries } from "src/redux/industries/selectors";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const ChooseIndustry: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();
  const { data: industries } = useAppSelector(selectIndustries);
  const industryField = getIndustryField(industries);

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.chooseYourIndustry)}
        </h2>

        <div>
          <RenderFormFields fields={industryField} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
